import { CustomerGroupType } from '@raisin/events-tracking';

const VALID_VALUES: CustomerGroupType[] = ['retail', 'business', 'Raisin'];
const DEFAULT_VALUE: CustomerGroupType = 'Raisin';

export const validateValue = (value: string | undefined): value is CustomerGroupType => {
  if (typeof value !== 'string') {
    return false;
  }
  return VALID_VALUES.includes(value as CustomerGroupType);
};

export const guardDistributorValue = (value: string | undefined): CustomerGroupType => {
  if (!validateValue(value)) {
    return DEFAULT_VALUE;
  }
  return value;
};
